const DataSourceEnum = {
  Apollo: 'Apollo',
  ThirdParty: 'Third-Party',
};

export default DataSourceEnum;
